import { Pipe, PipeTransform } from '@angular/core';
import { ComparatorService } from '../../services/comparator-service';
import { PfandrechtBelastungMasterDetailEntryMeta } from '../../../core/gb-api';

@Pipe({
  name: 'orderByPfandrechtBelastungMaster'
})
export class OrderByPfandrechtBelastungMasterPipe implements PipeTransform {
  public constructor(private comperatorService: ComparatorService) {}

  transform(array, ascending = true): Array<PfandrechtBelastungMasterDetailEntryMeta> | any {
    if (ascending) {
      return Array.from(array).sort((item1: PfandrechtBelastungMasterDetailEntryMeta, item2: PfandrechtBelastungMasterDetailEntryMeta) => {
        return this.comperatorService.pfandrechtBelatungMasterComparator(item1, item2);
      });
    } else {
      return Array.from(array).sort((item1: PfandrechtBelastungMasterDetailEntryMeta, item2: PfandrechtBelastungMasterDetailEntryMeta) => {
        return this.comperatorService.pfandrechtBelatungMasterComparator(item1, item2);
      });
    }
  }
}
